module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"download":"Download QR-code","show":"View","update":"Edit","delete":"Delete","socialLink":"Social Link","createQR":"Create a layout with a QR code"}}')
  delete Component.options._Ctor
}
